module.exports = __webpack_public_path__ + "static/img/ticket_off.88b37683.svg";